import {
  CHART_DIMENSIONS,
  CHART_VERTICAL_VALUE_LABEL_MIN_BAR_WIDTH_PX,
  DENSITY_BAR_THRESHOLD,
} from 'components/partials/charts/shared/chart-tokens';

import { AI_ASSISTANT_CHAT_MESSAGE_MAX_WIDTH_PX } from '../../../ai-assistant.constants';

export type BarChartOrientation = 'vertical' | 'horizontal';
export const VERTICAL_CHART_FORCE_MAX_WIDTH_RATIO = 0.9;
export const VERTICAL_CHART_FORCE_MAX_WIDTH_THRESHOLD_PX =
  AI_ASSISTANT_CHAT_MESSAGE_MAX_WIDTH_PX * VERTICAL_CHART_FORCE_MAX_WIDTH_RATIO;
export const MOBILE_HORIZONTAL_DEFAULT_BAR_THRESHOLD = 12;
export const DESKTOP_HORIZONTAL_DEFAULT_BAR_THRESHOLD = 30;

/** Total bar slots in a grouped bar chart. */
export const chartSlots = (
  categoryCount: number,
  seriesCount: number
): number => Math.max(0, categoryCount) * Math.max(0, seriesCount);

export const isDenseChart = (
  slots: number,
  threshold: number = DENSITY_BAR_THRESHOLD
): boolean => slots >= threshold;

export const shouldForceVerticalChartFrameMaxWidth = (
  plotMaxWidthPx: number
): boolean => plotMaxWidthPx > VERTICAL_CHART_FORCE_MAX_WIDTH_THRESHOLD_PX;

export const decideBarChartOrientation = (
  isMobileViewport: boolean,
  categoryCount: number,
  seriesCount: number,
  mobileThreshold: number = MOBILE_HORIZONTAL_DEFAULT_BAR_THRESHOLD,
  desktopThreshold: number = DESKTOP_HORIZONTAL_DEFAULT_BAR_THRESHOLD
): BarChartOrientation => {
  const slots = chartSlots(categoryCount, seriesCount);
  const threshold = isMobileViewport ? mobileThreshold : desktopThreshold;

  return isDenseChart(slots, threshold) ? 'horizontal' : 'vertical';
};

/** Smallest container width (px) at which chart-wide vertical value labels fit. */
export const valueLabelMinContainerWidthPx = (
  categoryCount: number,
  seriesCount: number
): number => {
  const slots = Math.max(1, chartSlots(categoryCount, seriesCount));

  return (
    slots *
      (CHART_VERTICAL_VALUE_LABEL_MIN_BAR_WIDTH_PX + CHART_DIMENSIONS.barGap) +
    CHART_DIMENSIONS.plotContainerPaddingPx
  );
};

/** Max plot width (px): slots × max bar size + horizontal chrome (padding + y-axis gutter). */
export const resolvePlotMaxWidth = (
  categoryCount: number,
  seriesCount: number
): number => {
  const slots = chartSlots(categoryCount, seriesCount);

  return (
    slots * CHART_DIMENSIONS.maxBarSizePx +
    CHART_DIMENSIONS.plotContainerPaddingPx
  );
};
